module.exports = __webpack_public_path__ + "img/result_graph.cc417228.png";